const isIe11 = () => {
  return window.navigator.userAgent.indexOf('Trident') !== -1
}

const executeOnceAfterDocumentReady = (listener) => {
  if (document.readyState !== 'loading') {
    listener()
  } else {
    document.addEventListener('DOMContentLoaded', listener, { once: true })
  }
}

const executeOnceAfterDocumentReadyWithIe11Resources = (
  listener,
  ie11Resources,
) => {
  if (isIe11()) {
    let loadedIe11ResourcesCount = 0
    const done = function done(event) {
      if (event && this && this.onload && this.onerror) {
        this.onload = null
        this.onerror = null
        if (event.type === 'error') {
          // eslint-disable-next-line no-console
          console.warn(`Cannot load IE 11 resource ${this.href || this.src}`)
        }
      }
      loadedIe11ResourcesCount += 1
      if (ie11Resources.length === loadedIe11ResourcesCount) {
        executeOnceAfterDocumentReady(listener)
      }
    }
    const isStyleRegex = /\.css(?:[?#].*)?$/i
    const isScriptRegex = /\.js(?:[?#].*)?$/i
    ie11Resources.forEach((src) => {
      if (isStyleRegex.test(src)) {
        const style = document.createElement('link')
        style.setAttribute('rel', 'stylesheet')
        style.setAttribute('href', src)
        style.setAttribute(
          'media',
          'all and (-ms-high-contrast: none), (-ms-high-contrast: active)',
        )
        style.onload = done
        style.onerror = done
        document.head.appendChild(style)
      } else if (isScriptRegex.test(src)) {
        const script = document.createElement('script')
        script.setAttribute('src', src)
        script.setAttribute('defer', 'defer')
        script.async = false
        script.onload = done
        script.onerror = done
        document.head.appendChild(script)
      } else {
        // eslint-disable-next-line no-console
        console.warn(`Wrong IE 11 resource ${src}`)
        done()
      }
    })
  } else {
    executeOnceAfterDocumentReady(listener)
  }
}

export {
  isIe11,
  executeOnceAfterDocumentReady,
  executeOnceAfterDocumentReadyWithIe11Resources,
}
